export enum NotificationEvent {
  HEADLINE_NEW = 'HEADLINE_NEW',
  TODO_OVERDUE = 'TODO_OVERDUE',
  TODO_NEW = 'TODO_NEW',
  PAGE_ASSIGNMENT = 'PAGE_ASSIGNMENT',
  SUBMISSION = 'SUBMISSION',
  SUBMISSION_ANSWER = 'SUBMISSION_ANSWER',
  INVENTORY_ORDER = 'INVENTORY_ORDER',
}
